import { useEffect } from "react";

export const ApropoRedirector = () => {
  useEffect(() => {
    if (import.meta.env.APP_APP_ORIGIN_DOMAIN)
      window.location.replace(import.meta.env.APP_APP_ORIGIN_DOMAIN);
  }, []);
  
  return <></>;
};